const FLIGHTS_SENTENCES = [
    "Flights.postbookLoader.confirmingSeats",
    "Flights.postbookLoader.securingFare",
    "Flights.postbookLoader.processingDetails",
    "Flights.postbookLoader.checkingAirline",
    "Flights.postbookLoader.reservingSpot",
    "Flights.postbookLoader.verifyingPassengers",
    "Flights.postbookLoader.finalizingItinerary",
    "Flights.postbookLoader.issuingTicket",
    "Flights.postbookLoader.lockingSeats",
    "Flights.postbookLoader.syncingSchedule",
    "Flights.postbookLoader.preparingBoarding",
    "Flights.postbookLoader.confirmingBaggage",
    "Flights.postbookLoader.generatingReference",
    "Flights.postbookLoader.packingDetails",
    "Flights.postbookLoader.almostThere",
]

export {FLIGHTS_SENTENCES};